import keyMirror from 'react-utils/keyMirror';

// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!FormsUI/img/types/r... Remove this comment to see the full error message
import regularImageUrl from 'bender-url!FormsUI/img/types/regular.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!FormsUI/img/types/s... Remove this comment to see the full error message
import shareableImageUrl from 'bender-url!FormsUI/img/types/shareable.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!FormsUI/img/types/p... Remove this comment to see the full error message
import popOverImageUrl from 'bender-url!FormsUI/img/types/pop_over.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!FormsUI/img/types/b... Remove this comment to see the full error message
import slideLeftImageUrl from 'bender-url!FormsUI/img/types/bottom_left.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!FormsUI/img/types/b... Remove this comment to see the full error message
import slideRightImgaeUrl from 'bender-url!FormsUI/img/types/bottom_right.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!FormsUI/img/types/t... Remove this comment to see the full error message
import dropdownBannerImageUrl from 'bender-url!FormsUI/img/types/top.png';
// @forms-fe-devs: waiting on design to provide us with a new png since this one shows a white border when the card is highlighted
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!FormsUI/img/types/t... Remove this comment to see the full error message
import newEditorFormImageUrl from 'bender-url!FormsUI/img/types/new_editor_form.png';
export const FormCreationTypeImagesMap = Object.freeze({
  LEGACY_FORM_EDITOR: regularImageUrl,
  REGULAR: regularImageUrl,
  SHAREABLE: shareableImageUrl,
  POP_OVER: popOverImageUrl,
  TOP: dropdownBannerImageUrl,
  BOTTOM_LEFT: slideLeftImageUrl,
  BOTTOM_RIGHT: slideRightImgaeUrl,
  NEW_EDITOR: newEditorFormImageUrl
});
export const PopUpFormTypes = keyMirror({
  POP_OVER: null,
  TOP: null,
  BOTTOM_LEFT: null,
  BOTTOM_RIGHT: null
});
export const RegularFormTypes = keyMirror({
  REGULAR: null,
  SHAREABLE: null
});
export const NewEditorFormTypes = keyMirror({
  NEW_EDITOR: null
});
export const RegularFormTypesNewEditor = keyMirror(Object.assign({}, NewEditorFormTypes, {
  LEGACY_FORM_EDITOR: null
}));
export const FormCreationTypes = Object.freeze(Object.assign({}, RegularFormTypes, RegularFormTypesNewEditor, PopUpFormTypes));
export const META_DATA_KEYS = {
  EMBED_TYPE: 'embedType'
};